import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { preprocessTextAsyncAutocompleteField } from "@/features/FormCard/utils";
import { z } from "zod";

/**
 * Enum options extracted from Ruby:
 *   Settings.keyword_categories = ["Commodities", "Country", "Economical zone", "Factor", "Continent", "Market type", "Nature", "New keywords", "Sector", "Size", "Sub sector", "Theme", "Underlyings"]
 */
export const categoryOptions = [
  { value: "Commodities", label: "Commodities" },
  { value: "Country", label: "Country" },
  { value: "Economical zone", label: "Economical zone" },
  { value: "Factor", label: "Factor" },
  { value: "Continent", label: "Continent" },
  { value: "Market type", label: "Market type" },
  { value: "Nature", label: "Nature" },
  { value: "New keywords", label: "New keywords" },
  { value: "Sector", label: "Sector" },
  { value: "Size", label: "Size" },
  { value: "Sub sector", label: "Sub sector" },
  { value: "Theme", label: "Theme" },
  { value: "Underlyings", label: "Underlyings" },
];

export const filterKeywordsSchema = z.object({
  name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional(),
  category_contains: z.string().nullable().optional(),
});

export type FilterKeywordsSchema = z.infer<typeof filterKeywordsSchema>;

export const fields: Field[] = [
  {
    name: "name_contains",
    label: "Name",
    type: "asyncAutocomplete",
    base_url: "ia-quantilia/keywords",
    column_name: "name",
  },
  {
    name: "category_contains",
    label: "Category",
    type: "select",
    useTranslation: false,
    options: categoryOptions,
  },
];

export const client = "ia-quantilia";

export function FilterKeywords() {
  return (
    <FilterTable
      client={client}
      schema={filterKeywordsSchema}
      tableName="keywords"
      customBuildPath={() => `${client}/keywords`}
      fields={fields}
    />
  );
}
